import React, {Component} from 'react';
import {connect} from 'react-redux';
import {changeHead} from '../../actions/actionsStructure';
import {browserHistory, Link} from 'react-router';
import {checkIsLogin, logout} from '../../../AdminProtectora/actions/actionsAdmin';
import {HeadMenuNotLogin} from './HeadMenuNotLogin/HeadMenuNotLogin';
import HeadMenuLogin from './HeadMenuLogin/HeadMenuLogin';
import {
    PATH_ADOPTAR,
    PATH_BUSCADOR_ANIMALES_ADMIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID,
    PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO,
    PATH_BUSCADOR_ANIMALES_ADMIN_CAMBIAR_CONTRASENA,
    PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL,
    PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO,
    PATH_BUSCADOR_ANIMALES_ADMIN_SERVICIOS,
    PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS,
    PATH_BUSCADOR_PETFRIENDLY_TIPO
} from "../../../../App/RouterAdopta";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {sendEvent} from "../../../../analytics/analitycs"


class Head extends Component {
    constructor(props) {
        super(props);
        // this.props = {
        //     reducerAccess: {
        //         isLogin: false,
        //         isChecked: false
        //     }
        // }
        
        
        this.goSignUp = this.goSignUp.bind(this);
        this.goHome = this.goHome.bind(this);
        this.goLogout = this.goLogout.bind(this);
        this.goFaqs = this.goFaqs.bind(this);
        this.goHall = this.goHall.bind(this);
        this.goChangePassword = this.goChangePassword.bind(this);
        this.goAdminAnimals = this.goAdminAnimals.bind(this);
    }
    
    
    goBusqueda() {
        browserHistory.push(PATH_ADOPTAR);
        
    }
    
    goLogin() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        
        /*let animationEnd =
          'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        console.log('PreviousPath --> ' + this.props.previousPath);
        if (this.props.previousPath === 'home') {
          let width = window.innerWidth;

          if (width < 992) {
            $('#row-filter').addClass('animated-400ms fadeOut');
            $('#raza-div').addClass('animated-0s flipOutX');
            $('.mouse_scroll').addClass('animated-0s fadeOut');
            $('.mouse_scroll').show();
            $('#buscar-home-div').addClass('animated-0s flipOutX')
              .one(animationEnd, function () {
                $('#buscar-home-div').hide();
                $('.index-resume__heading')
                  .addClass('animated fadeOutUp')
                  .one(animationEnd, function () {
                    browserHistory.push('/login');
                  });
              });
          } else {
            $('#row-filter')
              .addClass('animated flipOutX')
              .one(animationEnd, function () {
                $('.index-resume__heading').addClass('animated fadeOutUp');
                $('.mouse_scroll').addClass('animated-0s fadeOut');
                $('.mouse_scroll').show();
                $('#raza-div').addClass('animated-0s fadeOutLeft');
                $('#buscar-home-div').addClass('animated-0s fadeOutRight')
                  .one(animationEnd, function () {
                    $('#buscar-home-div').hide();
                    browserHistory.push('/login');
                  });
              });
          }
        } else if (
          this.props.previousPath === 'signup' ||
          this.props.previousPath === 'contact'
        ) {
          $('.page-login')
            .removeClass('animated fadeIn')
            .addClass('animated fadeOut')
            .one(animationEnd, () => {
              browserHistory.push('/login');
            });
        } else if (this.props.previousPath === 'adoptar') {
          $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');

          var width = window.innerWidth;

          //Caso móvil - tablet
          if (width < 992) {
            $('.icon-wrapper')
              .removeClass('animated fadeInLeft')
              .addClass('animated fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/login');
              });
          } else {
            $('#animals-filter')
              .removeClass('fadeInLeft')
              .addClass('fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/login');
              });
          }
        } else if (this.props.previousPath === 'protectoraDetail') {
          $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');
          $('.card-detail-protectora').removeClass('fadeIn').addClass('fadeOut');

          var width = window.innerWidth;

          //Caso móvil - tablet
          if (width < 992) {
            $('.icon-wrapper')
              .removeClass('animated fadeInLeft')
              .addClass('animated fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/login');
              });
          } else {
            $('#animals-filter')
              .removeClass('fadeInLeft')
              .addClass('fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/login');
              });
          }
        } else {
          browserHistory.push('/login');
        }*/
    }
    
    goLogout() {
        //console.log("Head::goLogout()");
        this.props.logout();
        
        //console.log("Head::goLogout() -> Cambio a ruta login -> " + PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
    }
    
    goFaqs() {
        //browserHistory.push('/info/preguntas-frecuentes');
    }
    
    goSignUp() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO);
        
        /*let animationEnd =
          'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        if (this.props.previousPath === 'home') {
          let width = window.innerWidth;

          if (width < 992) {
            $('#row-filter').addClass('animated fadeOut');
            $('#raza-div').addClass('animated-0s flipOutX');
            $('.mouse_scroll').addClass('animated-0s fadeOut');
            $('.mouse_scroll').show();
            $('#buscar-home-div').addClass('animated-0s flipOutX')
              .one(animationEnd, function () {
                $('#buscar-home-div').hide();
                $('.index-resume__heading')
                  .addClass('animated fadeOutUp')
                  .one(animationEnd, function () {
                    browserHistory.push('/signup');
                  });
              });
          } else {
            $('#row-filter')
              .addClass('animated flipOutX')
              .one(animationEnd, function () {
                $('.index-resume__heading').addClass('animated fadeOutUp');
                $('.mouse_scroll').addClass('animated-0s fadeOut');
                $('.mouse_scroll').show();
                $('#raza-div').addClass('animated-0s fadeOutLeft');
                $('#buscar-home-div').addClass('animated-0s fadeOutRight')
                  .one(animationEnd, function () {
                    $('#buscar-home-div').hide();
                    browserHistory.push('/signup');
                  });
              });
          }
        } else if (
          this.props.previousPath === 'login' ||
          this.props.previousPath === 'contact'
        ) {
          $('.page-login')
            .removeClass('animated fadeIn')
            .addClass('animated fadeOut')
            .one(animationEnd, () => {
              browserHistory.push('/signup');
            });
        } else if (this.props.previousPath === 'adoptar') {
          $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');

          var width = window.innerWidth;

          //Caso móvil - tablet
          if (width < 992) {
            $('.icon-wrapper')
              .removeClass('animated fadeInLeft')
              .addClass('animated fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/signup');
              });
          } else {
            $('#animals-filter')
              .removeClass('fadeInLeft')
              .addClass('fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/signup');
              });
          }
        } else if (this.props.previousPath === 'protectoraDetail') {
          $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');
          $('.card-detail-protectora').removeClass('fadeIn').addClass('fadeOut');

          var width = window.innerWidth;

          //Caso móvil - tablet
          if (width < 992) {
            $('.icon-wrapper')
              .removeClass('animated fadeInLeft')
              .addClass('animated fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/signup');
              });
          } else {
            $('#animals-filter')
              .removeClass('fadeInLeft')
              .addClass('fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/signup');
              });
          }
        } else {
          browserHistory.push('/signup');
        }*/
    }
    
    goHome() {
        browserHistory.push('/');
        
        /*let animationEnd =
            'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        if (
            this.props.previousPath === 'login' ||
            this.props.previousPath === 'registro' ||
            this.props.previousPath === 'contact'
        ) {
            $('.page-login')
                .removeClass('animated fadeIn')
                .addClass('animated fadeOut')
                .one(animationEnd, () => {
                    browserHistory.push('/');
                });
        } else if (this.props.previousPath === 'adoptar') {
            $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');

            var width = window.innerWidth;

            //Caso móvil - tablet
            if (width < 992) {
                $('.icon-wrapper')
                    .removeClass('animated fadeInLeft')
                    .addClass('animated fadeOutLeft')
                    .one(animationEnd, function () {
                        browserHistory.push('/');
                    });
            } else {
                $('#animals-filter')
                    .removeClass('fadeInLeft')
                    .addClass('fadeOutLeft')
                    .one(animationEnd, function () {
                        browserHistory.push('/');
                    });
            }
        } else if (
            this.props.previousPath === 'protectoraDetail' ||
            this.props.previousPath === 'animalDetail'
        ) {
            if (this.props.previousPath === 'protectoraDetail') {
                $('.card-detail-protectora')
                    .removeClass('animated fadeIn')
                    .addClass('animated fadeOut');
            } else if (this.props.previousPath === 'animalDetail') {
                $('.card-detail-animal')
                    .removeClass('animated fadeIn')
                    .addClass('animated fadeOut')
                    .one(animationEnd, function () {
                        browserHistory.push('/');
                    });
            }
            $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');

            var width = window.innerWidth;

            //Caso móvil - tablet
            if (width < 992) {
                $('.icon-wrapper')
                    .removeClass('animated fadeInLeft')
                    .addClass('animated fadeOutLeft')
                    .one(animationEnd, function () {
                        browserHistory.push('/');
                    });
            } else if (this.props.previousPath === 'protectoraDetail') {
                $('#animals-filter')
                    .removeClass('fadeInLeft')
                    .addClass('fadeOutLeft')
                    .one(animationEnd, function () {
                        browserHistory.push('/');
                    });
            } else {
                browserHistory.push('/');
            }
        } else {
            browserHistory.push('/');
        }

         */
    }
    
    goAdminAnimals() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + this.props.access.id);
    }
    
    goAnimalNuevo() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO);
        
    }
    
    goHall() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
        /*let animationEnd =
          'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        if (
          this.props.previousPath === 'login' ||
          this.props.previousPath === 'signup' ||
          this.props.previousPath === 'contact'
        ) {
          $('.page-login')
            .removeClass('animated fadeIn')
            .addClass('animated fadeOut')
            .one(animationEnd, () => {
              browserHistory.push('/admin');
            });
        } else if (this.props.previousPath === 'adoptar') {
          $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');

          var width = window.innerWidth;

          //Caso móvil - tablet
          if (width < 992) {
            $('.icon-wrapper')
              .removeClass('animated fadeInLeft')
              .addClass('animated fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/admin');
              });
          } else if (this.props.previousPath === 'protectoraDetail') {
            $('#animals-filter')
              .removeClass('fadeInLeft')
              .addClass('fadeOutLeft')
              .one(animationEnd, function () {
                browserHistory.push('/admin');
              });
          } else {
            browserHistory.push('/admin');
          }
        } else if (
          this.props.previousPath === 'protectoraDetail' ||
          this.props.previousPath === 'animalDetail'
        ) {
          if (this.props.previousPath === 'protectoraDetail') {
            $('.card-detail-protectora')
              .removeClass('animated fadeIn')
              .addClass('animated fadeOut');
          } else if (this.props.previousPath === 'animalDetail') {
            $('.card-detail-animal')
              .removeClass('animated fadeIn')
              .addClass('animated fadeOut');
          }
          $('#animals-list-container').removeClass('fadeIn').addClass('fadeOut');

          var width = window.innerWidth;

          //Caso móvil - tablet
          if (width < 992) {
            $('.icon-wrapper')
              .removeClass('animated fadeInLeft')
              .addClass('animated fadeOutLeft')
              .one(animationEnd, function () {
                console.log("to /admin");
                browserHistory.push('/admin');
              });
          } else if (this.props.previousPath === 'protectoraDetail') {
            $('#animals-filter')
              .removeClass('fadeInLeft')
              .addClass('fadeOutLeft')
              .one(animationEnd, function () {

                browserHistory.push('/admin');
              });
          } else {
            browserHistory.push('/admin');
          }
        } else {
          browserHistory.push('/admin');
        }
        console.log("to /admin de seguirdad");
        browserHistory.push('/admin');*/
    }
    
    goContact() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS);
    }
    
    goContactWA() {
        sendEvent('click',
            'app_boton_wa_soporte',
            {
                id_protectora: this.props.access.id, email_protectora: this.props.access.user,
                hostname: window.location.hostname, pathname: window.location.pathname, href: window.location.href
            })
    }
    
    goChangePassword() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_CAMBIAR_CONTRASENA);
    }
    
    goPerfil() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL);
    }
    
    goServicios() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_SERVICIOS);
    }
    
    
    /* Set the width of the side navigation to 250px and the left margin of the page content to 250px */
    openNav() {
        $("#sidenav-left-login").addClass("sidenav-open")
        $(".main-content").addClass("main-content-sidenav-open")
        
        $(".closebtn-sidenav").show()
        // $(".openbtn-sidenav").hide()
        
    }
    
    /* Set the width of the side navigation to 0 and the left margin of the page content to 0 */
    closeNav() {
        $("#sidenav-left-login").removeClass("sidenav-open")
        $(".main-content").removeClass("main-content-sidenav-open")
        $(".closebtn-sidenav").hide()
        // $(".openbtn-sidenav").show()
    }
    
    
    toggleActive(elem) {
        if (elem.currentTarget.classList.contains("site-nav--active-dropdown")) {
            elem.currentTarget.classList.remove("site-nav--active-dropdown")
        } else {
            elem.currentTarget.classList.add("site-nav--active-dropdown")
            
        }
        
    }
    
    render() {
        let imgHeaderSrc;
        // if ($(window).width() < 992) {
        imgHeaderSrc = process.env.CDN_URL + '/images/adoptaunanimal/icon/LOGO_ADOPTA_horiz_2021_448x120_fondo.jpeg'
        // }else{
        //     imgHeaderSrc = process.env.CDN_URL + '/images/adoptaunanimal/icon/LOGO_ADOPTA_horiz_2021_516x185_fondo2.jpeg'
        // }
        return (
            <div className="header-default main-content">
                {/*{(this.props.access.isLogin) ?*/}
                {
                    this.props.access.isLogin && <a className="buttonContact-wa" title="Contacta con nosotros"
                                                    href={"https://api.whatsapp.com/send?phone=++34699252717&text=Hola%20*soporte*,%20me%20puedes%20ayudar%20con"}
                                                    target="_blank" rel="nofollow" onClick={() => this.goContactWA()}>
                        <span className="lab la-2x la-whatsapp" aria-hidden="true"/>
                    </a>
                }
                {/*:*/}
                {/*this.props.previousPath !== 'contact' && (*/}
                {/*    <button className="buttonContact" title="Contacta con nosotros" onClick={() => this.goContact()}>*/}
                {/*        <span className="las la-question" aria-hidden="true"/>*/}
                {/*    </button>*/}
                {/*)*/}
                {/*}*/}
                <div className="header-topbar">
                    <div className="header-conteiner">
                        <button onClick={this.openNav} type="button"
                                className="btn btn-outline-secondary dropdown-item openbtn-sidenav"
                                aria-label="Left Align">
                            <span className="las la-lg la-bars" aria-hidden="true"/>{' '}
                        </button>
                        <div className="header-topbar__icon-head">
                            <LazyLoadImage
                                className="iconHead"
                                threshold={150}
                                src={imgHeaderSrc}/>
                            {/*src={getImageEncode("dogicon.58x58")}/>*/}
                            {/*<a onClick={this.goHome} className="navbar-brand" href="#">*/}
                            {/*    Adopta un <span className="colored-logo ">animal</span>*/}
                            {/*</a>*/}
                        
                        </div>
                        <div className="head-menu-navigation" id="AccessibleNav"
                             role="navigation">
                            
                            <ul className="site-nav list--inline" id="SiteNav">
                                <li className="site-nav--active"
                                    onClick={this.toggleActive}
                                    // onMouseEnter={this.toggleActive}
                                    // onMouseLeave={this.toggleActive}
                                >
                                    {/*<a*/}
                                    {/*    rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/?utm_source=buscador&utm_medium=header"*/}
                                    {/*    className="site-nav__link site-nav__link--main site-nav__link--active"*/}
                                    {/*    aria-current="page">*/}
                                    <span className="site-nav__label chevron">🛍 Tienda</span>
                                    {/*</a>*/}
                                    
                                    
                                    <div className="site-nav__dropdown critical-hidden site-nav__dropdown--left"
                                         id="SiteNavLabel-perros">
                                        
                                        <ul>
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-para-perros?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link">
                                                    <span className="site-nav__label">🐶 Pienso para Perros</span>
                                                </a>
                                            </li>
    
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-grain-free-sin-cereales-perro?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link margin-submenu">
                                                    <span className="site-nav__label">🥔 Grain Free para perros (Sin cereales)</span>
                                                </a>
                                            </li>
    
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/products/adopta-pienso-para-perro-hipoalergenico-grain-free-salmon-y-pato?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link margin-submenu">
                                                <span
                                                    className="site-nav__label">❤️ Pienso HIPOALERGÉNICO para perro</span>
                                                </a>
                                            </li>
    
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/snacks-para-perro?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link site-nav__link--last margin-submenu">
                                                    <span
                                                        className="site-nav__label">🦴 Snacks naturales para perro</span>
                                                </a>
                                            </li>
    
    
                                            <li className="bar-top">
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-para-perros?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link">
                                                    <span className="site-nav__label">🐈 Pienso para Gatos</span>
                                                </a>
                                            </li>
    
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-grain-free-sin-cereales-perro?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link margin-submenu">
                                                    <span className="site-nav__label">✅ Pienso PREMIUM para gato</span>
                                                </a>
                                            </li>
    
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-hipoalergenico-para-perro?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link margin-submenu">
                                                    <span className="site-nav__label">🔥 Pienso SUPER PREMIUM para gato</span>
                                                </a>
                                            </li>
    
                                            <li>
                                                <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/snacks-para-perro?utm_source=buscador&utm_medium=header"
                                                   className="site-nav__link site-nav__child-link site-nav__link--last margin-submenu">
                                                    <span
                                                        className="site-nav__label">🍬 Snacks naturales para gatos</span>
                                                </a>
                                            </li>
                                        </ul>
                                    
                                    </div>
                                
                                
                                </li>
                                
                                {/*<li className="site-nav--active"><a*/}
                                {/*    rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/?utm_source=buscador&utm_medium=header"*/}
                                {/*    className="site-nav__link site-nav__link--main site-nav__link--active"*/}
                                {/*    aria-current="page"><span*/}
                                {/*    className="site-nav__label">Colecciones</span></a></li>*/}
                                <li className="site-nav--active">
                                    <Link
                                        to={PATH_ADOPTAR + "?utm_source=buscador&utm_medium=header"}
                                        className="site-nav__link site-nav__link--main site-nav__link--active"
                                        aria-current="page">
                                        <span
                                            className="site-nav__label">🔎 Adoptar</span></Link>
                                
                                
                                </li>
                                <li className="site-nav--active">
                                    <Link
                                        to={PATH_BUSCADOR_PETFRIENDLY_TIPO.replace(":tipo_entity", "protectora") + "?utm_source=buscador&utm_medium=header"}
                                        className="site-nav__link site-nav__link--main site-nav__link--active"
                                        aria-current="page">
                                        <span
                                            className="site-nav__label">🏡 Protectoras</span></Link></li>
                                <li className="">
                                    <a
                                        href="https://blog.adopta-un-animal.es/?utm_source=buscador&utm_medium=header"
                                        className="site-nav__link site-nav__link--main" target="_blank"
                                        aria-describedby="a11y-new-window-external-message" rel="follow"><span
                                        className="site-nav__label">📝 Blog</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/pages/quienes-somos?utm_source=buscador&utm_medium=header"
                                        className="site-nav__link site-nav__link--main"
                                        aria-describedby="a11y-new-window-external-message"><span
                                        className="site-nav__label">🙋‍♂️‍🐕‍🦺 Quiénes somos</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        {/*<ul className="nav header-topbar__nav ">*/}
                        {/*    <li className="nav-item dropdown nav-item-head nav-link-dropdown">*/}
                        {this.props.access.isLogin ? (
                            <HeadMenuLogin
                                logout={this.goLogout}
                                hall={this.goHall}
                                goServicios={this.goServicios}
                                goAnimalNuevo={this.goAnimalNuevo}
                                goAdminAnimals={this.goAdminAnimals}
                                contact={this.goContact}
                                faqs={this.goFaqs}
                                changePassword={this.goChangePassword}
                                goPerfil={this.goPerfil}
                                onCloseNav={this.closeNav}
                                onOpenNav={this.openNav}
                            />
                        ) : (
                            <HeadMenuNotLogin
                                goBusqueda={this.goBusqueda}
                                login={this.goLogin}
                                signUp={this.goSignUp}
                                contact={this.goContact}
                                faqs={this.goFaqs}
                                onCloseNav={this.closeNav}
                                onOpenNav={this.openNav}
                            />
                        )}
                        {/*</li>*/}
                        {/*</ul>*/}
                    
                    </div>
                </div>
                <div className="header-topbar-mobile">
                    {/*<div className="container header-conteiner">*/}
                    <nav className="head-menu-navigation-mobile nav-mobile" id="AccessibleNav" role="navigation">
                        <ul className="site-nav list--inline" id="SiteNav">
                            
                            <li className="site-nav--active"
                                onClick={this.toggleActive}
                            >
                                <div
                                    className="site-nav__link site-nav__link--main site-nav__link--active"
                                >
                                
                                {/*<a*/}
                                {/*    rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/?utm_source=buscador&utm_medium=header"*/}
                                {/*    className="site-nav__link site-nav__link--main site-nav__link--active"*/}
                                {/*    aria-current="page">*/}
                                <span className="site-nav__label chevron">🛍 Tienda</span>
                                {/*</a>*/}
                                </div>
                                
                                
                                <div className="site-nav__dropdown critical-hidden site-nav__dropdown--left"
                                     id="SiteNavLabel-perros">
                                    
                                    <ul>
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-para-perros?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link">
                                                <span className="site-nav__label">🐶 Pienso para Perros</span>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-grain-free-sin-cereales-perro?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link margin-submenu">
                                                <span className="site-nav__label">🥔 Grain Free para perros (Sin cereales)</span>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/products/adopta-pienso-para-perro-hipoalergenico-grain-free-salmon-y-pato?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link margin-submenu">
                                                <span
                                                    className="site-nav__label">❤️ Pienso HIPOALERGÉNICO para perro</span>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/snacks-para-perro?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link site-nav__link--last margin-submenu">
                                                    <span
                                                        className="site-nav__label">🦴 Snacks naturales para perro</span>
                                            </a>
                                        </li>
                                        
                                        
                                        <li className="bar-top">
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-para-perros?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link">
                                                <span className="site-nav__label">🐈 Pienso para Gatos</span>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-grain-free-sin-cereales-perro?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link margin-submenu">
                                                <span className="site-nav__label">✅ Pienso PREMIUM para gato</span>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/pienso-hipoalergenico-para-perro?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link margin-submenu">
                                                <span className="site-nav__label">🔥 Pienso SUPER PREMIUM para gato</span>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/snacks-para-perro?utm_source=buscador&utm_medium=header"
                                               className="site-nav__link site-nav__child-link site-nav__link--last margin-submenu">
                                                    <span
                                                        className="site-nav__label">🍬 Snacks naturales para gatos</span>
                                            </a>
                                        </li>
                                    </ul>
                                
                                </div>
                            
                            
                            </li>
                            {/*<li className="site-nav--active"><a*/}
                            {/*    rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/collections/?utm_source=buscador&utm_medium=header"*/}
                            {/*    className="site-nav__link site-nav__link--main site-nav__link--active"*/}
                            {/*    aria-current="page"><span*/}
                            {/*    className="site-nav__label">Colecciones</span></a></li>*/}
                            <li className="site-nav--active">
                                <Link to={PATH_ADOPTAR + "/?utm_source=buscador&utm_medium=header"}
                                      className="site-nav__link site-nav__link--main site-nav__link--active"
                                      aria-current="page">
                                    <span className="site-nav__label">🔎 Adoptar</span>
                                </Link>
                            </li>
                            <li className="site-nav--active">
                                <Link
                                    to={PATH_BUSCADOR_PETFRIENDLY_TIPO.replace(":tipo_entity", "protectora") + "?utm_source=buscador&utm_medium=header"}
                                    className="site-nav__link site-nav__link--main site-nav__link--active"
                                    aria-current="page">
                                        <span
                                            className="site-nav__label">🏡 Protectoras</span></Link></li>
                            <li className="site-nav--active">
                                <a
                                    href="https://blog.adopta-un-animal.es/?utm_source=buscador&utm_medium=header"
                                    className="site-nav__link site-nav__link--main" target="_blank"
                                    aria-describedby="a11y-new-window-external-message" rel="follow"><span
                                    className="site-nav__label">📝 Blog</span>
                                </a>
                            </li>
                            <li className="displayNoneMobile">
                                <a
                                    rel="follow" target="_blank" href="https://tienda.adopta-un-animal.es/pages/quienes-somos?utm_source=buscador&utm_medium=header"
                                    className="site-nav__link site-nav__link--main"
                                    aria-describedby="a11y-new-window-external-message" ><span
                                    className="site-nav__label">🙋‍♂️🐕‍🦺Quiénes somos</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    {/*</div>*/}
                </div>
                {/*<CookieConsent*/}
                {/*    debug={false}*/}
                {/*    buttonClasses={"accept-btn-cookie-consent-banner"}*/}
                {/*    containerClasses="cookie-consent-banner"*/}
                {/*    contentClasses="cookie-content-banner"*/}
                {/*    buttonText={"Aceptar"}*/}
                {/*    acceptOnScroll={true}*/}
                {/*    acceptOnScrollPercentage={25}*/}
                {/*    disableStyles={false}>*/}
                {/*    <span style={{fontSize: "16px",color: "black"}}>*/}
                {/*        Utilizamos cookies propias y de terceros para darte un mejor servicio y mostrarte publicidad. Al continuar, estarás aceptando su uso. <a*/}
                {/*        href='https://tienda.adopta-un-animal.es/policies/privacy-policy?utm_source=buscador&utm_medium=cookie-consent'*/}
                {/*        target='_blank' rel="nofollow">Leer más</a>.*/}
                {/*    </span>*/}
                {/*</CookieConsent>*/}
                {(process.env.NODE_ENV !== "production" || process.env.DEV_ENV !== "PRO") &&
                    <div className="s-alert-error s-alert-is-effect s-alert-effect-slide s-alert-show"
                        id="alert-dev-enviroment" /*style="top: 30px; right: 30px;"*/>
                        <div className="s-alert-box-inner">
                            <span className="las la-2x la-exclamation-triangle"></span>
                            <span>Esta web es una <strong>web PRIVADA como entorno de pruebas</strong>, vaya a la parte pública en <strong><a href="https://www.adopta-un-animal.es/buscar-pet-friendly?utm_source=pre_env">www.adopta-un-animal.es</a></strong> GRACIAS 😊🙏
                    </span>
                        </div>
                    </div>
                }
            </div>
        );
    }
    
    componentWillMount() {
        // console.log("Head::checkLogin()");
        // if (!this.props.reducerAccess.isChecked/* && !this.props.reducerAccess.isLogin*/) {
        //     this.props.isLogin();
        // }
    }
    
    componentDidMount() {
        if (!this.props.showHead) {
            this.props.changeHead(true);
        }
    }
}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        access: state.access,
    };
}

export default connect(mapStateToProps, {changeHead, logout, checkIsLogin})(Head);
